<template>
  <div class="ticketContent">
    <div class="ticket-tips">
      请持本人有效证件入区，请提前下载本页，以防门区网络拥阻造成不便
    </div>
    <!-- <div class="detail-title">
      <div class="name">姓名： {{ tiketDetail.customer_name }}</div>
    </div> -->
    <div class="ticketDetail">
      <p class="title">{{ tiketDetail.site_name }}</p>
      <p>
        <span>{{ tiketDetail.ticket_kind_name }}</span>
        <span class="amount">￥{{ orderAmount }}</span>
        <span class="ticketDesc">({{ tiketDetail.status_desc }})</span>
      </p>
      <p>预约旅游日期</p>
      <p class="datetime">{{ goDate }}</p>
      <div class="qrcode" ref="qrCodeUrl"></div>
      <div class="item">
        <span>证件姓名</span>
        <span
          >{{ tiketDetail.customer_name }}({{
            tiketDetail.customer_type_name
          }})</span
        >
      </div>
      <div class="item">
        <span>证件类型</span>
        <span>{{ tiketDetail.id_type_name }}</span>
      </div>
      <div class="item">
        <span>证件号</span>
        <span>{{ tiketDetail.id_number }}</span>
      </div>
      <div class="item">
        <span>购票时间</span>
        <span>{{ sell_time }}</span>
      </div>
      <div class="item">
        <span>用户渠道</span>
        <span>{{ tiketDetail.sell_channel_name }}</span>
      </div>
      <!-- <div class="item">
        <span>客服电话</span>
        <span>{{ servePhone }}</span>
      </div> -->
      <!-- <div class="item">
        <span>验票时间</span>
        <span>2021-07-08</span>
      </div>
      <div class="item">
        <span>验票方式</span>
        <span>boss</span>
      </div> -->
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2';
import base from '../api/base';
import moment from 'moment';
import { getTicketStatusDesc } from '../setup/common';
export default {
  data() {
    return {
      params: '',
      tiketDetail: {},
      goDate: '',
      sell_time: '',
      orderAmount: '',
      servePhone: '',
    };
  },
  computed: {
    ticket() {
      return this.params;
    },
  },
  mounted() {
    console.log('params ===> ', this.$route.params);
    this.params = this.$route.params.code;
    this.servePhone = localStorage.getItem('service_phone');
    /*this.creatQrCode();*/
    this.getQueryByCode();
  },
  methods: {
    creatQrCode(ticketStatus, ticket_code) {
      let qrColor = '';
      console.log(ticketStatus);
      if (ticketStatus == 10) {
        qrColor = '#000000';
      } else {
        qrColor = '#999999';
      }
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: ticket_code,
        width: 150,
        height: 150,
        colorDark: qrColor,
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    async getQueryByCode() {
      const ticketDetailGet = await base.getQueryByCode({
        code: this.params,
      });
      console.log('票详情是', JSON.stringify(ticketDetailGet));
      this.tiketDetail = ticketDetailGet;
      let startTimeStr = moment(ticketDetailGet.start_time).format('HH:mm');
      let endTimeStr = moment(ticketDetailGet.end_time).format('HH:mm');
      let startDay = moment(ticketDetailGet.start_time).format('yyyy-MM-DD');
      this.goDate = startDay + '  ' + startTimeStr + '-' + endTimeStr;
      this.sell_time = moment(ticketDetailGet.sell_time).format(
        'yyyy-MM-DD HH:mm:ss',
      );
      this.orderAmount = (ticketDetailGet.sell_price / 100).toFixed(2);
      this.creatQrCode(ticketDetailGet.status, ticketDetailGet.qr_code);
    },
    getTicketStatusStr(status) {
      return getTicketStatusDesc(parseInt(status));
    },
  },
};
</script>

<style scoped lang="less">
.ticketContent {
  width: 100%;
  height: 100vh;
  background: #f8f8f8;
}
.ticket-tips {
  margin-bottom: 10px;
  padding: 10px;
  color: #e95b00;
  line-height: 20px;
  background-color: #ffeee1;
}
.detail-title {
  display: flex;
  justify-content: space-between;
  margin: 0 10px;
  padding: 10px 25px;
  line-height: 30px;
  background-image: linear-gradient(90deg, #798cf2, #6fc7f9);
  .name {
    color: #fff;
    font-size: 18px;
  }
}
.ticketDetail {
  margin: 0 10px;
  padding: 15px 0;
  text-align: center;
  background-color: white;
  .title {
    font-weight: 500;
    font-size: 18px;
  }
  p,
  span {
    padding: 5px 0;
  }
  .amount {
    color: #f15b49;
    font-size: 18px;
  }
  .ticketDesc {
    color: #999;
  }
  p.datetime {
    margin-bottom: 10px;
    color: #999;
  }
  .qrcode {
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #ddd;
    text-align: center;
    /deep/ img {
      width: 150px;
      margin: 0 auto;
    }
  }
  .item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 0 15px;
  }
}
</style>
